import Swal from 'sweetalert2';

export const useAlert = () => {
  const confirm = (title, confirmButtonText) => {
    return Swal.fire({
      title,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText,
    });
  };
  const success = (message) => {
    return Swal.fire(message, '', 'success');
  };

  const error = (message) => {
    return Swal.fire(message, '', 'error');
  };

  return { success, error, confirm };
};
